import { useEffect, useState } from 'react';
import { debounce } from 'lodash';
const useScroll = ({ scrollRef, currentAccessoryModalId, currentViewMoreModalId }) => {
    const [scrollTop, setScrollTop] = useState(0);
    useEffect(() => {
        const handleScroll = debounce(() => {
            if (scrollRef.current) {
                setScrollTop(scrollRef.current.scrollTop);
            }
        }, 50);
        const scrollElement = scrollRef.current;
        if (scrollElement) {
            scrollElement.addEventListener('scroll', handleScroll);
        }
        return () => {
            handleScroll.cancel();
            if (scrollElement) {
                scrollElement.removeEventListener('scroll', handleScroll);
            }
        };
    }, [scrollRef, setScrollTop, currentAccessoryModalId, currentViewMoreModalId]);
    useEffect(() => {
        if (scrollRef.current) {
            // eslint-disable-next-line no-param-reassign
            scrollRef.current.scrollTop = scrollTop;
        }
    }, [scrollRef, scrollTop, currentAccessoryModalId]);
};
export default useScroll;
